import ky from 'ky';

let base_url = 'https://data.basetre.com';
let token = 'WoxDgFKeSRdaGEj4jJxhAk-id4zP8rZd';
let endpoint = ky.create({
  prefixUrl: base_url + '/',
  headers: {
    'Authorization': 'Bearer ' + token
  }
});

export class api {
  static base_url = base_url;

  static async post_results(answers) {
    let body = {
      ...answers.a,
      ...answers.extra
    }
    return await endpoint.post('items/business2030_answers', {json: body});
  }
}